import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  href?: string;
  onBeforeNavigate?: () => void;
}
export function Button({
  children,
  onClick,
  className = '',
  variant = 'primary',
  href,
  onBeforeNavigate
}: ButtonProps) {
  const baseStyles = 'flex items-center justify-center text-center px-8 py-4 text-lg font-bold rounded-xl transition-all duration-300 shadow-sm hover:shadow-md';
  const variants = {
    primary: 'bg-leaf text-white hover:bg-forest hover:-translate-y-1',
    secondary: 'bg-forest text-white hover:bg-ink hover:-translate-y-1',
    outline: 'border-2 border-forest text-forest hover:bg-forest hover:text-white'
  };
  const isHash = href?.startsWith('#');
  const Component = href && !isHash ? motion.a : motion.button;
  const handleClick = () => {
    if (isHash && href) {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else if (onClick) {
      onClick();
    }
  };
  const handleExternalClick = (e: React.MouseEvent) => {
    if (onBeforeNavigate) {
      onBeforeNavigate();
    }
  };
  const props = href && !isHash ? {
    href,
    onClick: handleExternalClick
  } : {
    onClick: handleClick
  };
  return <Component {...props} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${`${baseStyles} ${variants[variant]} ${className}`} text-[20px] bg-[#A2A130BA] border-2 border-white`} data-id="element-188">
      {children}
    </Component>;
}